<template>
  <b-sidebar backdrop :data-items="items" id="sidebar-car" bg-variant="light" sidebar-class="border-right border-secondary" width="450px">
    <template v-slot:title>
      <font-awesome-icon :icon="['fas', 'shopping-cart']"/> Artículos
    </template>
    <div class="p-2">
      <b-table
        small
        hover
        show-empty
        empty-text="Aun no agregas artículos a tu carrito"
        :fields="table.headers"
        :items="items">
        <template v-slot:cell(quantity)="row">
          <b-col sm="10 pl-0">
            <b-input min="1" type="number" size="sm" v-model="row.item.quantity" />
          </b-col>
        </template>
        <template v-slot:cell(amount)="row">
          {{ (row.item.quantity * row.item.price) | toCurrency }}
        </template>
        <template v-slot:cell(price)="row">
          {{ row.item.price | toCurrency }}
        </template>
        <template v-slot:cell(actions)="row">
          <b-button size="sm" @click="onRemoveItem(row.item)" variant="outline-secondary">
            <font-awesome-icon :icon="['fas', 'trash']" />
          </b-button>
        </template>
      </b-table>
      <table class="table table-hover table-sm">
        <tr>
          <th class="text-right">Total</th>
          <td class="text-right">{{ total | toCurrency }}</td>
        </tr>
      </table>
      <b-button block variant="outline-purple" to="/checkout">Pagar</b-button>
    </div>
  </b-sidebar>
</template>

<script>
export default {
  name: 'Cart',
  props: { items: { type: Array, default: () => [] } },
  computed: {
    total () {
      return this.items.reduce((acc, item) => {
        return acc + (item.quantity * item.price)
      }, 0)
    }
  },
  data () {
    return {
      table: {
        headers: [
          { key: 'quantity', label: 'Cant.', class: 'w-25' },
          { key: 'name', label: 'Nombre' },
          { key: 'price', label: 'P.U' },
          { key: 'amount', label: 'Total' },
          { key: 'actions', label: 'X' }
        ]
      }
    }
  },
  methods: {
    async onRemoveItem (item) {
      const confirm = await this.$bvModal.msgBoxConfirm(`¿Remover el artículo ${item.name}?`,
        { title: 'Confirme la acción', okTitle: 'Remover', cancelTitle: 'Cancelar', okVariant: 'secondary', cancelVariant: 'purple' })
      if (confirm) this.$store.commit('removeFromCart', item)
    }
  }
}
</script>
